export const iconFontAwesomeHouseholdTemperatureArrowDown = (
	<i className="fa-solid fa-temperature-arrow-down"></i>
);
